var parent = require('../../stable/object/set-prototype-of');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/actual/object/set-prototype-of.js
// module id = 4330
// module chunks = 25